import { WriteStream } from "fs";
import { Writable } from "stream";

/**
 * Encoder used to write a search index in a space efficient method.
 */
export class IndexEncoder {
  w: WriteStream;
  txtEnc = new TextEncoder();

  constructor(w: WriteStream) {
    this.w = w;
  }

  getIntSz(val: number) {
    let bytes = 1;

    while (val >= 1 << (bytes * 7)) {
      bytes++;
    }
    return bytes;
  }

  writeUnsignedInt(val: number) {
    let bytes = this.getIntSz(val);
    let buf = new Uint8Array(bytes);
    let bytesLeft = bytes;
    let i = 0;
    while (bytesLeft--) {
      buf[i++] = ((bytesLeft ? 1 : 0) << 7) | ((val >> (bytesLeft * 7)) & 0x7f);
    }
    this.w.write(buf);
  }

  writeString(val: string) {
    const buf = new Uint8Array(val.length * 4);
    const { read, written } = this.txtEnc.encodeInto(val, buf);
    if (read != val.length) {
      throw new Error("Token too big for buffer");
    }
    this.writeUnsignedInt(written);
    this.w.write(buf.subarray(0, written));
  }

  close() {
    this.w.end();
  }
}
